import { css, FlattenSimpleInterpolation } from 'styled-components';
import { mediaSmDown, mediaMdDown } from 'theme/helpers/css';

interface IAnyProp {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export const addStyleIfPropTruly = (propName: string, style: string) => (props: IAnyProp) => {
  if (props[propName]) {
    return css`
      ${style}
    `;
  }
};

export const addXsStyleIfPropTruly = (propName: string, style: string | FlattenSimpleInterpolation) => (
  props: IAnyProp
) => {
  if (props[propName]) {
    return mediaSmDown`
      ${style}
    `;
  }
};

export const addMdStyleIfPropTruly = (propName: string, style: string | FlattenSimpleInterpolation) => (
  props: IAnyProp
) => {
  if (props[propName]) {
    return mediaMdDown`
      ${style}
    `;
  }
};
